<div class="logo-container relative"><div class="gradient fill-relative"></div></div>